<template>
  <PageShell page="blogs">
    <div class="blog-landing">
      <div class="blog-header">
        <h1>WhatsApp Aero Blog - Guides, Tips & Latest Updates</h1>
        <p>Explore WhatsApp Aero blog for the latest guides, installation tips, update tutorials, feature breakdowns, and comparisons to help you get the most out of WhatsApp Aero.</p>
      </div>

      <div class="blog-list-row">
        <a
          :href="data.url"
          v-for="data in blogItems"
          :key="data.name"
          class="blog-list-item"
        >
          <div class="blog-list-img">
            <img :src="data.poster" :alt="data.title" />
          </div>
          <div class="blog-list-content">
            <h2 class="blog-list-title">{{ data.title }}</h2>
            <div class="blog-list-descript">{{ data.desc }}</div>
            <div class="blog-list-date">{{ data.date }}</div>
          </div>
        </a>
      </div>
    </div>
  </PageShell>
</template>

<script>
import '@/css/blog/blogspc.scss';
import PageShell from '@/components/PageShell.vue';
import doc from '@/documents/blogs.js';

export default {
  name: 'Blogs',
  components: { PageShell },
  data() {
    return { doc };
  },
  computed: {
    blogItems() {
      return this.doc.bloglist.en.slice().reverse();
    },
  },
};
</script>
